import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SharedSelect = _resolveComponent("SharedSelect")!
  const _component_UIButton = _resolveComponent("UIButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.b())
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.b('fields'))
    }, [
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.b('field'))
      }, [
        _createElementVNode("p", {
          class: _normalizeClass(_ctx.b('field-label'))
        }, "Выберите страну", 2),
        _createVNode(_component_SharedSelect, {
          view: "light",
          options: _ctx.displayedCountryOptions,
          icon: _ctx.adminCurrency.country,
          value: _ctx.adminCurrency.country,
          "is-search": true,
          "onUpdate:value": _ctx.handleCountry
        }, null, 8, ["options", "icon", "value", "onUpdate:value"])
      ], 2),
      (_ctx.isCurrencyShow)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.b('field'))
          }, [
            _createElementVNode("p", {
              class: _normalizeClass(_ctx.b('field-label'))
            }, "Валюта", 2),
            _createVNode(_component_SharedSelect, {
              view: "light",
              options: _ctx.displayedCurrencyOptions,
              icon: _ctx.adminCurrency.name ? _ctx.adminCurrency.country : '',
              "is-search": true,
              value: _ctx.adminCurrency.name,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.adminCurrency.name) = $event))
            }, null, 8, ["options", "icon", "value"])
          ], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_component_UIButton, {
      label: _ctx.displayedButtonLabel,
      view: "main",
      disabled: _ctx.isButtonDisabled,
      onClick: _ctx.handleButton
    }, null, 8, ["label", "disabled", "onClick"])
  ], 2))
}